export const supportEmail = 'support@braindate.com';
